import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { toast } from "react-toastify";
import jwt_decode from "jwt-decode";

const LoginGuard = () => {
  const [auth, setAuth] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      try {
        const decodedToken = jwt_decode(token);
        const currentTime = Date.now() / 1000;
        if (decodedToken.exp < currentTime) {
          localStorage.removeItem("token");
          setAuth(false);
          toast.error("Session expired. Please login again.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          setAuth(true);
        }
      } catch (error) {
        localStorage.removeItem("token");
        setAuth(false);
        toast.error("Invalid token. Please login again.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } else {
      setAuth(false);
    }

    setLoading(false);
  }, []);

  if (loading) {
    return <div>Loading...</div>; // Show loading state while checking the token
  }

  return auth ? <Outlet /> : <Navigate to="/login" />;
};

export default LoginGuard;
